import { DatesModel } from "../..";
import { Retriever, IState, IClock, ITimeZoneObservable, ToggleTabEvent } from "../../../../common";
import { IDatesGateway } from "..";

export class DatesRetriever extends Retriever<DatesModel> {

    private readonly datesGateway: IDatesGateway;
    private readonly toggleTabEvent: ToggleTabEvent;
    private readonly clock: IClock;
    private readonly addTimeAfterMidnight: number;
    private readonly timeZoneObservable: ITimeZoneObservable;
    private readonly keepSelectedDay: boolean;

    private sportId?:string;
    private midnightUpdateTimeout: number;
    private isActive: boolean;
    private state!: IState<DatesModel>;
    private currentSelectedTimeZone?: number;
    private parentBlockId?: string;

    constructor(datesGateway: IDatesGateway, hideTabEvent: ToggleTabEvent, clock: IClock, timeZoneObservable: ITimeZoneObservable, keepSelectedDay: boolean) {
        super();
        this.datesGateway = datesGateway;
        this.toggleTabEvent = hideTabEvent;
        this.clock = clock;
        this.timeZoneObservable = timeZoneObservable;
        this.midnightUpdateTimeout = -1;
        this.addTimeAfterMidnight = 1000;
        this.keepSelectedDay = keepSelectedDay;
        this.isActive = false;
    }

    async setParams(sportId?: string, parentBlockId?: string)
    {
        this.sportId = sportId;
        this.parentBlockId = parentBlockId;

        await this.refreshData();
        if(!this.keepSelectedDay && this.state && this.state.Items.length) {
            this.state.selectItem(this.state.Items[0]);
        }
    }

    async onPanelEnter() {
        await this.timeZoneObservable.observe((timeZone) => this.updateTimeZone(timeZone));
    }

    onPanelLeave() {
        this.currentSelectedTimeZone = undefined;
        this.toggleTabEvent.reset();
    }

    async activate(state: IState<DatesModel>) {
        this.isActive = true;
        this.state = state;
        await this.refreshData();
    }

    async refreshData() {
        this.currentSelectedTimeZone != undefined && this.sportId && await this.pullItems(this.currentSelectedTimeZone, this.sportId);
    }

    private async updateTimeZone(timezone: number) {
        this.currentSelectedTimeZone = timezone;
        this.sportId && await this.pullItems(timezone, this.sportId);
    }

    private async pullItems(timezone: number, sportId: string) {
        this.resetMidnightUpdateTimer(timezone, sportId);
        const dates = await this.datesGateway.GetDates(timezone, sportId);
        this.parentBlockId && this.toggleTabEvent.emit(dates, this.parentBlockId);
        this.isActive && this.state.replaceItems(dates, true);
    }

    private resetMidnightUpdateTimer(timezone: number, sportId: string) {
        clearTimeout(this.midnightUpdateTimeout);
        const timeTillMidnight = this.clock.getTimeTillMidnight(timezone);
        this.midnightUpdateTimeout = window.setTimeout(() =>
            this.pullItems(timezone, sportId), timeTillMidnight + this.addTimeAfterMidnight);
    }

    deactivate() {
        this.isActive = false;
        clearTimeout(this.midnightUpdateTimeout);
    }
}
